export default __webpack_public_path__ + "static/media/obj.b8a526f6.svg";